<template>
  <span class="caption flex items-center gap-8">
    <RevRating :score="average" /> ({{ count }})</span
  >
</template>

<script setup lang="ts">
import { RevRating } from '@ds/components/Rating'

defineProps<{ average: number; count: number }>()
</script>
